import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog, SttList } from '../../../sporttia/all';

type Props = {
    open?: boolean;
    errors?: string[];
    onClose: () => void;
};

export default function NewMessageResultDialog({
    open = false,
    errors = [],
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <SttDialog
            title={t('MessageSent')}
            open={open}
            onClose={onClose}
            content={
                <>
                    <Box py={2}>
                        <Box mb={1}>{t('page.sc.comm.noteNoEmail')}</Box>
                        <Box>{t('page.sc.comm.emailTime')}</Box>
                    </Box>

                    {errors && errors.length > 0 && (
                        <SttList
                            title={t('Errors')}
                            numRows={8}
                            data={errors.map((error: any) => ({
                                caption: error,
                            }))}
                        />
                    )}
                </>
            }
            buttons={[
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
        />
    );
}
